import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStubhubComponent } from './simple-icons-stubhub.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStubhubComponent ],
    exports:      [ SimpleIconsStubhubComponent ],
    bootstrap:    []
})
export class SimpleIconsStubhubModule {}
